import React, { useState ,useEffect} from 'react';
import Dialog from '../index';
import style from './CreateAccount.module.scss';
import FirstStep from './First';
import SecondStep from './Second';
import Third from './Third';
import AdditionalDataStep from './AdditionalData';
import {errorPushEmployerSelector} from "../../../../store/settings/selectors";
import {useSelector} from "react-redux";
import usePermissions from '../../../Core/usePermissions'

const initialUser = {
  photo: '',
  email: '',
  name: '',
  surname: '',
  external_id: null,
  hours_demand: '',
  approver_1: null,
  approver_2: null,
  effective_date: null,
  childrens: null,
  child_born_1: null,
  child_born_2: null,
  child_born_3: null,
  child_born_4: null,
  child_born_5: null,
  child_born_6: null,
  child_born_7: null,
  child_born_8: null,
  child_born_9: null,
  child_born_10: null,
  child_born_1_disabled: false,
  child_born_2_disabled: false,
  child_born_3_disabled: false,
  child_born_4_disabled: false,
  child_born_5_disabled: false,
  child_born_6_disabled: false,
  child_born_7_disabled: false,
  child_born_8_disabled: false,
  child_born_9_disabled: false,
  child_born_10_disabled: false,
  skill: null,
  subgroup: null,
  group: null,
  cost: null,
  charge: null,
  place_ids: [],
  shift_id: null,
  role_id: null,
  job_type_id: null,
  assign_shift_id: null,
  assign_job_type_id: null,
  password: '',
  passport_number: '',
  passport_valid_date: '',
  phone_number: '',
  birth_date: '',
  shirt_size: '',
  pants_size: '',
  boots_size: '',
  notes: '',
  iiko_user_id: null,
}

export default function CreateAccount({
  handleClose,
  title,
  open,
  companyId,
  skills,
  groups,
  places,
  shifts,
  job_types,
  roles,
  security,
  createAccount,
  firstUser,
}) {

  const permissions = usePermissions([
    {
      name: 'can_add_additional_employee_data',
      module: 'can_add_additional_employee_data',
    },
    {
      name: 'iiko_profitability',
      module: 'iiko_profitability',
    },
  ]);

  const totalSteps = permissions?.can_add_additional_employee_data ? 4 : 3;
  
  const [step, setStep] = useState(1);

  const [user, setUser] = useState(initialUser);

  const stepUp = () => {
    setStep(prev => prev + 1)
  };
  const stepDown = () => {
    setStep(prev => prev - 1)
  };

  const closeStat = useSelector(errorPushEmployerSelector);

  // eslint-disable-next-line
  const close = () => {
    setUser(initialUser);
    setStep(1);
    handleClose();
  };

  const create = (data) => {
    createAccount(data);
    close();
  };
  useEffect(() => {
    if (closeStat === false) {
      close();
    }
  }, [closeStat, close]);
  const handleInput = (e) => {
    const {
      name,
      value,
    } = e.target;

    setUser((prevState) => {
      if (name !== 'group') {
        if (name === 'place_ids') {
          const nextValues = {
            ...prevState,
            [name]: value,
          };

          if (prevState.shift_id) {
            const foundShift = shifts.find(({ id }) => id === prevState.shift_id);
            if (!foundShift || !value.some((placeId) => Number(placeId) === Number(foundShift.place_id))) {
              delete nextValues.shift_id;
            }
          }

          if (prevState.assign_shift_id) {
            const foundShift = shifts.find(({ id }) => id === prevState.assign_shift_id);
            if (!foundShift || !value.some((placeId) => Number(placeId) === Number(foundShift.place_id))) {
              delete nextValues.assign_shift_id;
            }
          }

          if (prevState.job_type_id) {
            const foundJT = job_types.find(({ id }) => id === prevState.job_type_id);
            if (foundJT && !foundJT?.shifts.find(s => s.id === nextValues?.shift_id)) {
              delete nextValues.job_type_id;
            }
          }

          if (prevState.assign_job_type_id) {
            const foundJT = job_types.find(({ id }) => id === prevState.assign_job_type_id);
            if (foundJT && !foundJT?.shifts.find(s => s.id === nextValues?.assign_shift_id)) {
              delete nextValues.assign_job_type_id;
            }
          }

          return nextValues;
        }
        
        if (name === 'shift_id') {
          const nextValues = {
            ...prevState,
            [name]: value,
          };

          if (prevState.job_type_id) {
            const foundJT = job_types.find(({ id }) => id === prevState.job_type_id);
            if (foundJT && !foundJT?.shifts.find(s => s.id === value)) {
              delete nextValues.job_type_id;
            }
          }

          return nextValues;
        }

        if (name === 'assign_shift_id') {
          const nextValues = {
            ...prevState,
            [name]: value,
          };

          if (prevState.assign_job_type_id) {
            const foundJT = job_types.find(({ id }) => id === prevState.assign_job_type_id);
            if (foundJT && !foundJT?.shifts.find(s => s.id === value)) {
              delete nextValues.assign_job_type_id;
            }
          }

          return nextValues;
        }

        if (name === 'approver_1') {
          return {
            ...prevState,
            [name]: value || null,
            approver_2: value ? prevState.approver_2 : null,
          };
        }

        if (name === 'approver_2') {
          return {
            ...prevState,
            [name]: value || null,
          };
        }

        return {
          ...prevState,
          role_id: prevState.role_id || ((roles ? roles.find(r => r.default)?.id : null) || null),
          [name]: value,
        };
      }
      const {
        subgroup: $,
        ...rest
      } = prevState;
      
      return {
        ...rest,
        [name]: value,
      };
    });
  };

  return (
    <Dialog
      handleClose={close}
      open={open}
      title={title}
    >

      <div className={style.progress}>
        <div className={style.progress_inner}>
          <span className={style.active} style={{ width: `${(100 / totalSteps) * step}%` }} />
        </div>
      </div>
      <div className={style.newAccount}>
        <StepWrapper
          step={step}
          user={user}
          handleInput={handleInput}
          nextStep={stepUp}
          previousStep={stepDown}
          companyId={companyId}
          skills={skills}
          groups={groups}
          places={places}
          shifts={shifts}
          roles={roles}
          job_types={job_types}
          setUser={setUser}
          security={security}
          create={create}
          firstUser={firstUser}
          withAdditionalData={permissions?.can_add_additional_employee_data}
          withIiko={permissions?.iiko_profitability}
        />
      </div>

    </Dialog>
  );
}

const StepWrapper = ({
  step,
  withAdditionalData,
  ...rest
}) => {
  switch (step) {
    case 1:
      return <FirstStep {...rest} />
    case 2:
      if (withAdditionalData) {
        return <AdditionalDataStep {...rest} />
      }
      return <SecondStep {...rest} />
    case 3:
      if (withAdditionalData) {
        return <SecondStep {...rest} />
      }
      return <Third {...rest} />
    case 4:
      return <Third {...rest} />
    default:
      return null
  }
};
